import React from 'react'
import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer'
import { cadss_catalog_1, cadss_catalog_2 } from '../../../../escalas/cads/cads.catalog'
import { IMAGE_API, myHospitals } from '../../../../resources'

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
    },
    logo: {
        width: 80,
        height: 50,
        objectFit: 'contain',
    },
    headerRight: {
        textAlign: 'right',
        alignItems: 'flex-end',
    },
    title: {
        fontSize: 14,
        fontWeight: 700,
        color: '#505050',
    },
    subtitle: {
        fontSize: 10,
        marginTop: 2,
        color: '#505050',
    },
    infoRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 12,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 6,
        borderRadius: 4,
    },
    rowEven: {
        backgroundColor: '#f5f5f5',
    },
    question: {
        width: '85%',
    },
    answer: {
        width: '13%',
        textAlign: 'right',
    },
    divider: {
        borderBottomWidth: 1,
        borderBottomColor: '#d9d9d9',
        marginVertical: 10,
    },
    sectionTitle: {
        fontSize: 11,
        fontWeight: 700,
        marginBottom: 6,
    },
})

export default function CadsPDF({ pacienteData, fecha, cads = [] }) {
    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                <View style={styles.header}>
                    <Image src={IMAGE_API + myHospitals[0]?.logo} style={styles.logo} />
                    <View style={styles.headerRight}>
                        <Text style={styles.title}>Escala CADSS</Text>
                        {fecha && <Text style={styles.subtitle}>{new Date(fecha).toLocaleDateString('es-MX')}</Text>}
                    </View>
                </View>

                <View style={styles.infoRow}>
                    <Text>Paciente: {pacienteData?.name || '-'}</Text>
                </View>

                {
                    cadss_catalog_1.map((item, index) => (
                        <View key={index} style={index % 2 === 0 ? [styles.row, styles.rowEven] : styles.row}>
                            <Text style={styles.question}>{item}</Text>
                            <Text style={styles.answer}>{cads[index] ? "Si" : "No"}</Text>
                        </View>
                    ))
                }

                {
                    cadss_catalog_2.map((item, index) => (
                        <View key={index + 9} style={index % 2 === 1 ? [styles.row, styles.rowEven] : styles.row}>
                            <Text style={styles.question}>{item}</Text>
                            <Text style={styles.answer}>{cads[index + 9]}</Text>
                        </View>
                    ))
                }

                <View style={styles.divider} />
                <Text style={styles.sectionTitle}>CUESTIONARIO DE GUSTO Y APETENCIA A LA KETAMINA IV</Text>

                <View style={styles.row}>
                    <Text style={styles.question}>1. a.) En general, ¿cuánto le gustaron los efectos disociativos de la ketamina IV?</Text>
                    <Text style={styles.answer}>{cads[15]}</Text>
                </View>
                <View style={[styles.row, styles.rowEven]}>
                    <Text style={styles.question}>2. a.) En general, ¿cuánto anhela, apetece el tratamiento de la ketamina IV para otros efectos además de los efectos antidepresivos?</Text>
                    <Text style={styles.answer}>{cads[16]}</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.question}>2. b.) ¿Cuánto desea usar la ketamina IV en cantidades mayores con más frecuencia de lo que su psiquiatra le está prescribiendo por razones distintas a esperar más efecto antidepresivo?</Text>
                    <Text style={styles.answer}>{cads[17]}</Text>
                </View>
            </Page>
        </Document>
    )
}
